import { Suspense } from 'react';
import { useRoutes } from 'react-router-dom';

import LoadingScreen from '@/components/ui/LoadingScreen';

import routes from './config';

export function AppRoutes() {
  const element = useRoutes(routes);
  return <Suspense fallback={<LoadingScreen />}>{element}</Suspense>;
}
